import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useLocation } from 'react-router';
import { getLocalStorageTheme } from '../features/theme/themeActions';

import Header from './Header';
import Loading from './Loading'
import Footer from './Footer';

const Starfield = React.lazy(() => import('react-starfield'));

const Intro = React.lazy(() => import('./Intro'));
const About = React.lazy(() => import('./About'));
const Projects = React.lazy(() => import('./Projects'));
const Contact = React.lazy(() => import('./Contact'));
const Link = React.lazy(() => import('./Link'));

// render page title based on location pathname
const getPageTitle = (pathname) => {
  switch (pathname) {
    case '/':
      return 'Hello';
    case '/about':
      return 'Who Is Jaytee?';
    case '/projects':
      return 'Projects';
    case '/contact':
      return 'Contact Me';
    case '/link':
      return 'Link Up';
    default:
      return '';
  }
};

function App() {
  const darkMode = useSelector((state) => state.darkMode);
  const dispatch = useDispatch();
  const location = useLocation();

  // 
  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, [darkMode]);

  // side effect, so we use useEffect to synchronize the page title with the current route
  useEffect(() => {
    document.title = `Jaytee - Software Engineer | ${getPageTitle(location.pathname)}`;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // side effect, so we use useEffect to run our action creator to
  // get the theme from localStorage and set it in our Redux store
  useEffect(() => {
    dispatch(getLocalStorageTheme());
  }, [dispatch]);

  return (
    <React.Fragment>
      <Header />
      <main>
        <React.Suspense fallback={<Loading />}>
          <Routes>
            <Route path='/' element={<Intro sectionHeading='Jaytee' />} />
            <Route
              path='/about'
              element={<About sectionHeading='Who Is Jaytee?' />}
            />
            <Route
              path='/projects'
              element={<Projects sectionHeading='Projects' />}
            />
            <Route
              path='/contact'
              element={<Contact sectionHeading='Contact' />}
            />
            <Route path='/link' element={<Link sectionHeading='Link' />} />
            <Route path='*' element={<Intro sectionHeading='Jaytee' />} />
          </Routes>
        </React.Suspense>
      </main>
      <Footer />
      {darkMode && (
        <Starfield
          starCount={1000}
          starColor={[255, 255, 255]}
          speedFactor={0.05}
          backgroundColor='black'
        />
      )}
    </React.Fragment>
  );
}

export default App;
